import FormRow from '../../FormRow'
import { Field, RichTextEditor } from '../../../../react-final-form-wrappers'
import { useForm } from 'react-final-form'
import { useState } from 'react'
import { useFieldValue } from '../../../../hooks/useFieldValue'
import AuthenticationService from '../../../../services/AuthenticationService'
import { client } from '../../../../client/client'
import { useTranslation } from 'react-i18next'
import TemplateToolbarButton from '../../../../components/RichTextEditor/TemplateToolbarButton'

const NotesSection = ({ name }) => {
  const form = useForm()
  const { t } = useTranslation('settingsPage')
  const practiceId = useFieldValue('practice.id')
  const userId = AuthenticationService.getUserId()
  const showTemplateButton = name === 'intakeNote'
  const [replaceText, setReplaceText] = useState(null)
  const [replaceKey, setReplaceKey] = useState(0)

  const insertTemplate = async () => {
    const response = await client.getTemplate(userId, practiceId, name)
    const text = response?.status === 'success' ? response?.data?.template?.text : ''
    setReplaceText(text || '\u200b')
    setReplaceKey((k) => k + 1)
  }

  return (
    <FormRow>
      <Field
        fullWidth
        multiline
        name={name}
        component={RichTextEditor}
        replaceMarkdown={replaceText}
        replaceKey={replaceKey}
        toolbarCustomButtons={
          showTemplateButton
            ? [
                <TemplateToolbarButton
                  key="template"
                  onClick={insertTemplate}
                  title={t('template')}
                />
              ]
            : undefined
        }
      />
    </FormRow>
  )
}

export default NotesSection
